/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Feat3_BodyInputs */

const es_l7_feat3_body = /** @type {(inputs: L7_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te ayudamos —gratis— a encontrar el seguro que cubre el alquiler. Sin coste por nuestra parte.`)
};

const gl_l7_feat3_body = /** @type {(inputs: L7_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Axudámoste —de balde— a atopar o seguro que cobre o alugueiro. Sen custo da nosa parte.`)
};

const en_l7_feat3_body = /** @type {(inputs: L7_Feat3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We help you —free— find insurance that covers rental. No fee from us.`)
};

/**
* | output |
* | --- |
* | "We help you —free— find insurance that covers rental. No fee from us." |
*
* @param {L7_Feat3_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_feat3_body = /** @type {((inputs?: L7_Feat3_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Feat3_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_feat3_body(inputs)
	if (locale === "en") return en_l7_feat3_body(inputs)
	return es_l7_feat3_body(inputs)
});